import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import AppBar from 'react-toolbox/lib/app_bar'
import { compose } from 'redux'
import { Flex } from 'reflexbox'

import Image from './Image'
import MailboxNotification from './MailboxNotification'
import LogoutIconButton from './LogoutIconButton'
import ProfileIconLink from './ProfileIconLink'

import styles from './styles.scss'

const MainAppbar = (props) => {
  const {
    logout,
    count,
    name
  } = props
  return (
    <AppBar theme={styles}>
      <Flex styleName='appbarContainer' auto align='center'>
        <Flex styleName='imageContainer'>
          <Image src='/images/nv_white.png'/>
        </Flex>
        <Flex styleName='imageContainer'>
          <Image src='/images/logo_light.png'/>
        </Flex>
        <Flex auto justify='flex-end' align='center'>
          <MailboxNotification count={count}/>
          <ProfileIconLink/>
          <LogoutIconButton onClick={logout}/>
          <span styleName='username'>{name}</span>
        </Flex>
      </Flex>
    </AppBar>
  )
}

MainAppbar.propTypes = {
  count: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  logout: PropTypes.func
}

MainAppbar.defaultProps = {
  count: 0,
  name: ''
}

const withStyle = CSSModules(styles)
const enhance = compose(
  withStyle
)

export default enhance(MainAppbar)
